import { render, staticRenderFns } from "./DomiFilters.vue?vue&type=template&id=6bad8359&scoped=true&"
import script from "./DomiFilters.vue?vue&type=script&lang=js&"
export * from "./DomiFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad8359",
  null
  
)

export default component.exports